module.exports = __webpack_public_path__ + "static/media/rafiki.588d7948.svg";